import { render, staticRenderFns } from "./i4pro-label.vue?vue&type=template&id=4b9b7bbe&scoped=true"
import script from "./i4pro-label.vue?vue&type=script&lang=js"
export * from "./i4pro-label.vue?vue&type=script&lang=js"
import style0 from "./i4pro-label.vue?vue&type=style&index=0&id=4b9b7bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9b7bbe",
  null
  
)

export default component.exports